// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "h3[data-v-4e5f716d] {\n  text-align: center;\n  margin: 30px 0;\n}", "",{"version":3,"sources":["webpack://./development/vue-components/SectionSubTitle.vue"],"names":[],"mappings":"AAWA;EACI,kBAAA;EACA,cAAA;AAVJ","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\nh3 {\n    text-align: center;\n    margin: 30px 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
